import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
new Splide( '.splide' ).mount( { AutoScroll } );
import particles from "particles.js";
import anime from 'animejs/lib/anime.es.js';

(function () {
    "use strict";
	var getDevice = (function(){
		var ua = navigator.userAgent;
		if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
			return 'sp';
		}else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
			return 'tab';
		}else{
			return 'other';
		}
	})();
	let obj = {
		init : function(){
			this.opening();
			this.particlesJS();
      this.ham_btn();
      this.Gs_scroll();      
      this.Slider();      
      this.ChangeCursor();      
      this.Circle_svg();      
		},
		ChangeCursor : function(){
      var stalker=$("#stalker");
      $(document).on("mousemove",function(e){
        var x=e.clientX;
        var y=e.clientY;
        setTimeout(function(){
          stalker.css({
            "opacity":"1",
            "top":y+"px",
            "left":x+"px"
          });
        },140);
        $(".drag .splide__slide").on("mouseenter", function() {
          $('#stalker').addClass("active");
        });
        $(".drag .splide__slide").on("mouseleave", function() {
          $('#stalker').removeClass("active");
        });
        $(".drag .splide__slide a").on("mouseenter", function() {
          $('#stalker').removeClass("active");
        });
        $(".drag .splide__slide a").on("mouseleave", function() {
          $('#stalker').addClass("active");
        });
            
      });
    },
		Slider : function(){
      const options = {
        arrows : false,
        pagination: false
      };
      const splide = new Splide(".splide", options);
      splide.mount();
    },
		Circle_svg : function(){
      $(window).on('load resize', function(){
        if( getDevice == 'other' || getDevice == 'tab' ){        
        var dots = $(window).width()/1440;
        $('.circleArrow').css('transform','translate(-50%,-50%) scale(' + dots + ')');
        $('.circleBase').css('transform','translate(-50%,-50%) scale(' + dots + ')');
        }
      });
    },
		Gs_scroll : function(){
      let mu_t1 = gsap.utils.toArray(".move_up_tp_1");
      mu_t1.forEach(target => {
      gsap.set(target, {y: 200});
      gsap.to(target, { 
        y: 0,
        opacity: 1,
        duration: 1.2,
        ease: "back.out(.8)",
        scrollTrigger: {
          trigger: target,
          start: 'top center+=80%',
          toggleClass: {targets: target, className: "active"},
          toggleActions: "play pause resume reset", 
        }
      });
      });
      let mu_t2 = gsap.utils.toArray(".move_up_tp_2");
      mu_t2.forEach(target => {
      gsap.set(target, {y: 200});
      gsap.to(target, { 
        y: 0,
        duration: 1.2,
        ease: "back.out(.8)",
        delay: .1,
        scrollTrigger: {
          trigger: target,
          start: 'top center+=80%', 
          toggleClass: {targets: target, className: "active"},
          toggleActions: "play pause resume reset", 
        }
      }); 
      });
      let mu_t3 = gsap.utils.toArray(".move_up_tp_3");
      mu_t3.forEach(target => {
        gsap.set(target, {opacity: 0, y: 10});
        gsap.to(target, { 
          y: 0,
          opacity: 1,
          duration: 0.6,
          scrollTrigger: {
            trigger: target,
            start: 'top center+=80%', 
            toggleActions: "play pause resume reset", 
          }
        }); 
        });
        ////////
        ScrollTrigger.matchMedia({
        "(max-width: 767px)": function () {
        let mt_tx1 = gsap.utils.toArray(".move_tx_1");
        mt_tx1.forEach(target => {
          gsap.to(target, { 
            x: 100,
            duration: 0.6,
            ease: 'power2.out',
            inertia: true,
            scrollTrigger: {
              trigger: target,
              start: 'top center+=80%', 
              scrub: 2,
              toggleActions: "play pause resume reset", 
            }
          }); 
          });
          //
          let mt_tx1_r = gsap.utils.toArray(".move_tx_1_right");
          mt_tx1_r.forEach(target => {
            gsap.to(target, { 
              x: -100,
              duration: 0.6,
              ease: 'power2.out',
              inertia: true,
              scrollTrigger: {
                trigger: target,
                start: 'top center+=80%', 
                scrub: 2,
                toggleActions: "play pause resume reset", 
              }
            }); 
            });
        },
        "(min-width: 767px)": function () {
          let mt_tx1 = gsap.utils.toArray(".move_tx_1");
          mt_tx1.forEach(target => {
            gsap.to(target, { 
              x: 300,
              duration: 0.6,
              ease: 'power2.out',
              inertia: true,
              scrollTrigger: {
                trigger: target,
                start: 'top center+=80%', 
                scrub: 2,
                toggleActions: "play pause resume reset", 
              }
            }); 
            });
            //
            let mt_tx1_r = gsap.utils.toArray(".move_tx_1_right");
            mt_tx1_r.forEach(target => {
              gsap.to(target, { 
                x: -300,
                duration: 0.6,
                ease: 'power2.out',
                inertia: true,
                scrollTrigger: {
                  trigger: target,
                  start: 'top center+=80%', 
                  scrub: 2,
                  toggleActions: "play pause resume reset", 
                }
              }); 
              });
  
          }
      
  
       
          /////  


          }); 
            //
            ScrollTrigger.matchMedia({
              "(max-width: 767px)": function () {
            var pinAmount = $(".home .sec_7 .inn .beside").outerWidth() / 3;
            var horizontal_scroll_tl = gsap.timeline({
              scrollTrigger: {
                trigger: ".home .sec_7",
                scrub: 1.5,
                pin: ".home .sec_7",
                start: "top top",
                end: () => `+=${pinAmount}`
              }})   
              horizontal_scroll_tl.to(".home .sec_7 .inn .beside", {xPercent: -62,ease: "none"})
            },
              "(min-width: 767px)": function () {
                var pinAmount = $(".home .sec_7 .inn .beside").outerWidth() / 15;
                var horizontal_scroll_tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: ".home .sec_7",
                    scrub: 1.5,
                    pin: ".home .sec_7",
                    start: "top top",
                    end: () => `+=${pinAmount}`
                  }})   
                  horizontal_scroll_tl.to(".home .sec_7 .inn .beside", {xPercent: -62,ease: "none"})
    
              }
          }); 
              //
              window.addEventListener("DOMContentLoaded", () => {
                const navLinks = document.querySelectorAll("nav.cmmn ul li a");
                navLinks.forEach((navLink) => {
                  if (
                    navLink.hasAttribute("href") &&
                    navLink.getAttribute("href").startsWith("#")
                  ) {
                    navLink.addEventListener("click", (e) => {
                      e.preventDefault();
                      gsap.to(window, {
                        duration: 1,
                        ease: "power3.inOut",
                        scrollTo: {
                          y: navLink.getAttribute("href"),
                          offsetY: 0,
                          autoKill: true
                        }
                      });
                    });
                  }
                });
              });
              //
              let move_fow_up_1 = document.querySelector(".home .sec_8 .inn .bxs.line_no_1");
                gsap.to(move_fow_up_1, { 
                  scrollTrigger: {
                    trigger: move_fow_up_1,
                    start: 'top center+=10%', 
                    toggleClass: {targets: move_fow_up_1, className: "on"},
                    toggleActions: "play pause resume reset",           
                  }
                }); 
                let move_fow_up_1_in = document.querySelector(".home .sec_8 .inn .bxs.line_no_1 .in_wrap");
                gsap.to(move_fow_up_1_in, { 
                  y: 70,
                  duration: 0.6,
                  ease: 'power2.out',
                  inertia: true,
                  scrollTrigger: {
                    trigger: move_fow_up_1_in,
                    start: 'top center+=10%', 
                    scrub: 3,
                    toggleActions: "play pause resume reset",           
                  }
                }); 
                let move_fow_up_2 = document.querySelector(".home .sec_8 .inn .bxs.line_no_2");
                gsap.to(move_fow_up_2, { 
                  scrollTrigger: {
                    trigger: move_fow_up_2,
                    start: 'top center', 
                    toggleClass: {targets: move_fow_up_2, className: "on"},
                    toggleActions: "play pause",           
                  }
                }); 
                let move_fow_up_2_in = document.querySelector(".home .sec_8 .inn .bxs.line_no_2 .in_wrap");
                gsap.to(move_fow_up_2_in, { 
                  y: -70,
                  duration: 0.6,
                  ease: 'power2.out',
                  inertia: true,
                  scrollTrigger: {
                    trigger: move_fow_up_2_in,
                    start: 'top center+=10%', 
                    scrub: 3,
                    toggleActions: "play pause",           
                  }
                }); 
                let move_fow_up_3 = document.querySelector(".home .sec_8 .inn .bxs.line_no_3");
                gsap.to(move_fow_up_3, { 
                  scrollTrigger: {
                    trigger: move_fow_up_3,
                    start: 'top center+=10%', 
                    toggleClass: {targets: move_fow_up_3, className: "on"},
                    toggleActions: "play pause resume reset",           
                  }
                }); 
                let move_fow_up_3_in = document.querySelector(".home .sec_8 .inn .bxs.line_no_3 .in_wrap");
                gsap.to(move_fow_up_3_in, { 
                  y: 70,
                  duration: 0.6,
                  ease: 'power2.out',
                  inertia: true,
                  scrollTrigger: {
                    trigger: move_fow_up_3_in,
                    start: 'top center+=10%', 
                    scrub: 3,
                    toggleActions: "play pause resume reset",           
                  }
                }); 
              //
              window.addEventListener("DOMContentLoaded", () => {
                const menuLinks = document.querySelectorAll(".menu_lists a");
                const target = document.querySelector(".ham_btn");
                menuLinks.forEach((menuLink) => {
                  if (
                    menuLink.hasAttribute("href") &&
                    menuLink.getAttribute("href").startsWith("#")
                  ) {
                    menuLink.addEventListener("click", (e) => {
                      e.preventDefault();
                      target.click();  
                      gsap.to(window, {
                        duration: 1,
                        ease: "power3.inOut",
                        scrollTo: {
                          y: menuLink.getAttribute("href"),
                          offsetY: 0,
                          autoKill: true
                        }
                      });
                    });
                  }
                });
              });

      },
    ham_btn : function(){
      const target = document.querySelector(".ham_btn");
      target.addEventListener('click', function(){
      this.classList.toggle('is-menu-open');
      const DOM = {};
      DOM.intro = document.querySelector('.menu_lists');
      DOM.shape = DOM.intro.querySelector('svg.shape');
      DOM.px_img = DOM.intro.querySelectorAll('.s_bx');
      DOM.tx_h2 = DOM.intro.querySelector('.inn .tx h2 img');
      DOM.tx_span = DOM.intro.querySelectorAll('.inn .tx ul li a span');
      DOM.path = DOM.shape.querySelector('path');
      // Set the SVG transform origin.
      DOM.shape.style.transformOrigin = '50% 0%';
      document.body.classList.add("movin");

      if(target.classList.contains('is-menu-open') == true ){
        console.log("true");

        anime({
          targets: DOM.intro,
          duration: 1100,
          easing: 'easeInOutSine',
          top: '0',
          complete: function(anim) {
            inn();
          }
        });
      
          anime({
            targets: DOM.shape,
            scaleY: [
              {value:[0.8,1.8],duration: 550,easing: 'easeInQuad'},
              {value:1,duration: 550,easing: 'easeOutQuad'}
            ]
          });
      
          anime({
            targets: DOM.path,
            duration: 1100,
            easing: 'easeOutQuad',
            d: DOM.path.getAttribute('pathdata:id'),
            complete: function(anim) {
              document.body.classList.remove("movin");
            }
          });
          function inn(){
            
            anime({
              easing: 'easeInOutSine',
              targets: DOM.tx_h2,
              duration: 1000,
              //delay: anime.stagger(50),
              top: '0'
            });

            anime({
              easing: 'easeInOutSine',
              targets: DOM.tx_span,
              duration: 1000,
              //delay: anime.stagger(50),
              top: '0'
            });

               anime({
                easing: 'easeInOutSine',
                targets: DOM.px_img,
                duration: 400,
                opacity:1,
                delay: anime.stagger(100),
                top: '0'
              });         
            };

      }

      if(target.classList.contains('is-menu-open') == false ){
        anime({
          easing: 'easeInOutSine',
          targets: DOM.tx_span,
          duration: 1000,
          //delay: anime.stagger(50),
          top: '-5vw'
           });
            
           anime({
            easing: 'easeInOutSine',
            targets: DOM.tx_h2,
            duration: 1000,
            //delay: anime.stagger(50),
            top: '-5vw'
          });

           anime({
            easing: 'easeInOutSine',
            targets: DOM.px_img,
            duration: 400,
            opacity:0,
            delay: anime.stagger(100),
            top: '-20px',
            complete: function(anim) {
              closed();
            }  
          });         
        function closed(){  
        anime({
          targets: DOM.intro,
          duration: 1100,
          easing: 'easeInOutSine',
          top: '-200vh'
        });
        
        anime({
          targets: DOM.shape,
          scaleY: [
            {value:[0.8,1.8],duration: 550,easing: 'easeInQuad'},
            {value:1,duration: 550,easing: 'easeOutQuad'}
          ]
        });
    
        anime({
          targets: DOM.path,
          duration: 1100,
          easing: 'easeOutQuad',
          d: DOM.path.getAttribute('pathdata:id'),
          complete: function(anim) {
            document.body.classList.remove("movin");
          }
        });
      }
      }
    });
    },
		opening : function(){
      {
        const DOM = {};
        DOM.intro = document.querySelector('.load--intro');
        DOM.ico = DOM.intro.querySelector('.ico');
        DOM.shape = DOM.intro.querySelector('svg.shape');
        DOM.path = DOM.shape.querySelector('path');
        // Set the SVG transform origin.
        DOM.shape.style.transformOrigin = '50% 0%';
      
        const init = () => {
          window.addEventListener('load', navigate);
        };
        document.body.classList.add("movin");
        let loaded;
        const navigate = () => {
          if ( loaded ) return;
          loaded = true;
      
          function sleep(waitSec, callback) {
            setTimeout(callback, waitSec);		  
          }			
      
          sleep(1000, function() {
          
            anime({
              targets: DOM.ico,
              duration: 500,
              easing: 'easeInOutSine',
              translateY: '-10%',
              opacity: '0'
            });

            anime({
              targets: DOM.intro,
              duration: 1100,
              easing: 'easeInOutSine',
              translateY: '-200vh'
            });
              
            anime({
            targets: DOM.shape,
            scaleY: [
              {value:[0.8,1.8],duration: 550,easing: 'easeInQuad'},
              {value:1,duration: 550,easing: 'easeOutQuad'}
              ]
            });
      
            anime({
            targets: DOM.path,
            duration: 1100,
            easing: 'easeOutQuad',
            d: DOM.path.getAttribute('pathdata:id'),
            complete: function(anim) {
              DOM.intro.classList.add("display_non");
              document.body.classList.remove("movin");
              fv();
             }
           });

           function fv() {
            anime({
              targets: document.querySelector('.fv_stage .px img'),
              duration: 500,
              easing: 'linear',
              top: '0',
              opacity: '1',
              filter:'blur(0)'
            });
            
            anime({
              targets: document.querySelectorAll('.cap_left'),
              duration: 500,
              easing: 'linear',
              left: '0',
              opacity: '1',
              delay: anime.stagger(50)
            });

           }

        });  

        };
        init();
      };    
            
		},
    particlesJS : function(){
      window.addEventListener('load', function(){
        particlesJS('particles-js',{
          "particles": {
            "number": {
              "value": 20,//シェイプの数
              "density": {
                "enable": true,//密度を変更する
                "value_area": 1000//密集度
              }
            },
            //色
            "color": {
              "value": ["115bd1","21a0f0"]
            },
            //シェイプの形状
            "shape": {
              "type": "circle",//シェイプの形(円)
              "stroke": {
                "width": 0,//外線つけない
                "color": "#000000"//つける場合の線色
                }
            },
            //シェイプの透明度
            "opacity": {
              "value": 0.5,//透明度(1で不透明)
              "random": false,//透明度をランダムにしない
              //randomがtrueの場合
              "anim": {
                "enable": false,//透明度のアニメーションをしない
                "speed": 1,//アニメーションスピード
                "opacity_min": 0.1,//透明度の最小値
                "sync": false//各シェイプを同時に動かさない
              }
            },
            //シェイプの大きさ
            "size": {
              "value": 5,//大きさ
              "random": true,//大きさをランダムにする falseで均一
              "anim": {
                "enable": false,//シェイプの大きさをアニメーションしない
                "speed": 10,//アニメーションのスピード
                "size_min": 0.1,//サイズの最小値
                "sync": false//各シェイプを同時に動かさない
              }
            },
            //シェイプ間を結ぶ線
            "line_linked": {
              "enable_auto": false
            },
            //シェイプの動き
            "move": {
              "enable": true,//動きを付ける
              "speed": 2,//シェイプが動くスピード数値が大きいと早い
              "direction": "none",//動きの方向(none、top、top-right、right、bottom-right、bottom、bottom-left、left、top-left)
              "straight": false,//動きを動きを止めるか否か
              "out_mode": "bounce",//外枠に達した際のシェイプの動き　bounce→跳ね返る　out→フレームアウト
              /*シェイプを引き寄せる*/
              "attract": {
                "enable": false,//引き寄せない
                "rotateX": 600,//横軸の指定
                "rotateY": 1200//横軸の指定
              }
            }
          },
          //相互作用
          "interactivity": {
            "detect_on": "canvas",
            "events": {
              //カーソルを乗せた時の動き
              "onhover": {
                "enable": false,//無効
                "mode": "repulse"//enableがtrueの場合の動き(下の★のリストの名前入れるとその動きが発動)
              },
              //クリックしたときの動き
              "onclick": {
                "enable": false,//無効
                "mode": "push"//(下の★のリストの名前入れるとその動きが発動)
              },
              "resize":true//リサイズしたとき拡縮しない
            },
            //各モード設定した場合の動き
            "modes": {
              //★シェイプとカーソルの間に線ができる
              "grab": {
                "distance": 400,//カーソルからの反応距離
                "line_linked": {
                "opacity": 1//線の不当明度
                }
              },
              //★シェイプが膨らむ
              "bubble": {
                "distance": 200,//カーソルからの反応距離
                "size": 40,//膨らむ際の大きさ
                "duration": 2,//持続時間
                "opacity": 8,//透明度
                "speed": 3//速度
                },
              //★シェイプに触れるとカーソルから逃げる
              "repulse": {
                "distance": 200//カーソルからの反応距離
                },
              //★シェイプを増やす
              "push": {
                "particles_nb": 4//数
                },
              //★シェイプを減らす
              "remove": {
                "particles_nb": 2//数
              }
            }
          },
            "retina_detect": true,//Retina Display(*高画素密度のディスプレイ)を対応する
          }
        ); 
      });       
    },

	};
	obj.init();
}());